import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 32, className = "", once = true }) {
    const reduced = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduced ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.15 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    const reduced = useReducedMotion();
    return (
        <span className={`mask-line ${className}`}>
            <motion.span
                className="block"
                initial={reduced ? false : { y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1.1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function SectionHead({ eyebrow, title, serif = null, text = null, align = "left" }) {
    return (
        <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
            {eyebrow && (
                <Reveal>
                    <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-5" data-testid="section-eyebrow">
                        {eyebrow}
                    </p>
                </Reveal>
            )}
            <Reveal delay={0.08}>
                <h2 className="text-4xl sm:text-5xl font-light tracking-tighter leading-[1.02] text-ivory">
                    {title}{" "}
                    {serif && <span className="font-display italic text-gold">{serif}</span>}
                </h2>
            </Reveal>
            {text && (
                <Reveal delay={0.16}>
                    <p className="mt-6 text-base leading-relaxed text-smoke">{text}</p>
                </Reveal>
            )}
        </div>
    );
}
